import React from 'react';
import arrowright from '../assets/images/arrow-white.svg';
import logo from '../assets/images/logo.png';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          {/* Newsletter Section */}
          <div className="col-lg-6">
            <div className="footer-newsletter-box">
              <div className="footer-newsletter-title">
                <h3>Don't miss subscribe!</h3>
              </div>
              <div className="newsletter-form">
                <form id="newsletterForm" action="#" method="POST">
                  <div className="form-group">
                    <input 
                      type="email" 
                      name="email" 
                      className="form-control" 
                      id="mail" 
                      placeholder="Enter Your Email" 
                      required 
                    />
                    <button type="submit" className="newsletter-btn">
                      <img src={arrowright} alt="Submit" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div className="col-lg-2 col-md-4 col-6">
            <div className="footer-links">
              <h3>Company</h3>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/About">About Us</a></li>
                {/* <li><a href="services.html">Services</a></li> */}
                <li><a href="/Shipping">Shipping Policy</a></li>
                <li><a href="blog.html">Blog</a></li>
              </ul>
            </div>
          </div>

          {/* Support Links */}
          <div className="col-lg-2 col-md-4 col-6">
            <div className="footer-links">
              <h3>Support</h3>
              <ul>
                <li><a href="/cancellationRefund">cancellation & Refund</a></li>
                <li><a href="/privacy">Privacy Policy</a></li>
                <li><a href="/TermCondition">Term &amp; Condition</a></li>
                <li><a href="/Contact">Contact Us</a></li>
              </ul>
            </div>
          </div>

          {/* Service Links */}
          <div className="col-lg-2 col-md-4">
            <div className="footer-links">
              <h3>Service</h3>
              <ul>
                <li><a href="service-single.html">Financial Planning</a></li>
                <li><a href="service-single.html">Investment Management</a></li>
                <li><a href="service-single.html">Retirement Planning</a></li>
                <li><a href="service-single.html">Budgeting &amp; Forecasting</a></li>
              </ul>
            </div>
          </div>

          {/* Contact Section */}
          <div className="col-lg-12">
            <div className="footer-cta-box">
              <div className="footer-logo">
                <img src={logo} alt="Company Logo" />
              </div>
              <div className="footer-contact-box">
                {/* <div className="footer-contact-item"> */}
                  {/* <p>Need help!</p>
                  <h3>91-7339983554</h3> */}
                {/* </div> */}
                <div className="footer-contact-item">
                  <p>E-mail now</p>
                  <h3>sales@payinfintech.com</h3>
                </div>
                <div className="footer-contact-item">
                  <p>Address</p>
                  <h3>
                      Flat No. F-1, Plot No. 238-A, Nemi Nagar Vistar, Vaishali Nagar, Near 200 Feet Bypass, Jaipur – 302021, Rajasthan
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-copyright">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="footer-copyright-text">
                <p>Copyright © {new Date().getFullYear()} All Rights Reserved.</p>
              </div>
            </div>
            <div className="col-md-7">
              <div className="footer-menu">
                <ul>                            
                  <li><a href="#">LinkedIn</a></li>
                  <li><a href="#">Facebook</a></li>
                  <li><a href="#">Instagram</a></li>
                  <li><a href="#">Twitter</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
